import React, { memo } from 'react'
import { Grid } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'
import { EQUIPMENT_TYPE_KEY } from 'apps/marketplace/store/transfixLane/types'
import { getLargeEquipmentIcon } from 'apps/marketplace/utils/helpers/getIcon'
import { ShipperRateObjectAugmented } from 'apps/marketplace/utils/hooks/AwardedLanes/useAwardedLanesApi'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'
import { findEquipment } from 'constants/equipment'

interface ILaneHeaderProps {
  dataTest?: string
  loading?: boolean
  rate?: ShipperRateObjectAugmented | undefined
}

const LaneSkeleton = memo(() => (
  <Grid alignItems='center' container spacing={1}>
    <Grid item>
      <Skeleton height='25px' width='100px' variant='rectangular' />
    </Grid>
    <Grid item>|</Grid>
    <Grid item>
      <Skeleton height='25px' width='300px' variant='rectangular' />
    </Grid>
    <Grid item>
      <Skeleton height='25px' width='40px' variant='rectangular' />
    </Grid>
    <Grid item>
      <Skeleton height='25px' width='40px' variant='rectangular' />
    </Grid>
  </Grid>
))

export const LaneHeader = memo<ILaneHeaderProps>(({ dataTest, loading = false, rate }) => {
  const { equipment, lane, loadType, shipperApplication } = rate || { loadType: '' }
  const { name } = shipperApplication || {}
  const { key, name: equipmentName } = findEquipment(equipment?.parentId)

  return (
    <>
      {loading && !rate ? (
        <LaneSkeleton />
      ) : (
        <Grid data-test={dataTest} alignItems='center' container spacing={1}>
          <Grid item>{name}</Grid>
          <Grid item>|</Grid>
          <Grid item>{lane}</Grid>
          <Grid item>
            <Tag
              icon={getLargeEquipmentIcon(key as EQUIPMENT_TYPE_KEY, 'small')}
              label={equipmentName || 'Dry Van'}
              size={TAG_SIZE.xsmall}
              tagStyle={TAG_STYLE.info}
              className='mh2'
            />
          </Grid>
          <Grid item>
            <Tag label={loadType} size={TAG_SIZE.xsmall} tagStyle={TAG_STYLE.info} />
          </Grid>
        </Grid>
      )}
    </>
  )
})
